import { render, staticRenderFns } from "./collectStep2.vue?vue&type=template&id=15f9dd80&scoped=true"
import script from "./collectStep2.vue?vue&type=script&lang=ts"
export * from "./collectStep2.vue?vue&type=script&lang=ts"
import style0 from "./collectStep2.vue?vue&type=style&index=0&id=15f9dd80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f9dd80",
  null
  
)

export default component.exports